import React from 'react';
import styles from '../AvailabilityConfirm.module.css';
import moment from 'moment';

interface OfficeHoursTableProps {
    officeHours: never[];
    availabilityObject: any;
    // openingTime: string;
    // closingTime: string;
    // differentWeekEndAvailability?: boolean;
    // saturdayOpeningTime?: string | null;
    // saturdayClosingTime?: string | null;
    // sundayOpeningTime?: string | null;
    // sundayClosingTime?: string | null;
}

const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const OfficeHoursTable = ({ officeHours, availabilityObject }: OfficeHoursTableProps) => {

    return (
        <div className={styles.availabilityTable}>
            {!availabilityObject?.satSunAvailability && availabilityObject?.isOfficeHoursChecked && weekdays?.map((value: string, index: number) => {
                const availabilitySlots = availabilityObject.availabilitySlots;
                return (
                    <div className={styles.container} key={index}>
                        <div className={styles.header}>
                            <p>{value}</p>
                        </div>
                        <div className={styles.slotContainer}>
                            {availabilitySlots?.length ? availabilitySlots?.map((slot: { startTime: string, endTime: string }, idx: number) => {
                                return (
                                    <div className={styles.slot} key={idx}>
                                        <span>{moment(slot.startTime, 'HH:mm A').format('hh:mm A')}</span> - <span>{moment(slot.endTime, 'HH:mm A').format('hh:mm A')}</span>
                                    </div>
                                );
                            }) : 'Closed'}
                        </div>
                    </div>
                );
            })}

            {!availabilityObject?.satSunAvailability && !availabilityObject?.isOfficeHoursChecked && weekdays?.map((value: string, index: number) => {
                const availabilitySlots = JSON.parse(availabilityObject.availabilitySlots);
                return (
                    <div className={styles.container} key={index}>
                        <div className={styles.header}>
                            <p>{value}</p>
                        </div>
                        <div className={`${styles.slotContainer} ${styles.multiSlot}`}>
                            {availabilitySlots?.length ? (
                                availabilitySlots?.map((slot: { startTime: string; endTime: string }, idx: number) => {
                                    return (
                                        <div className={styles.slot} key={idx}>
                                            <span>{moment(slot.startTime, 'HH:mm A').format('hh:mm A')}</span> -{' '}
                                            <span>
                                                {moment(slot.endTime, 'HH:mm A').format('hh:mm A') === '12:00 AM'
                                                    ? '11:59 PM'
                                                    : moment(slot.endTime, 'HH:mm A').format('hh:mm A')}
                                            </span>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className={styles.slot} key={'closed'}>
                                    Closed
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}

            {!!availabilityObject?.satSunAvailability && !availabilityObject?.isOfficeHoursChecked && weekdays?.map((value: string, index: number) => {
                const availabilitySlots = JSON.parse(availabilityObject.availabilitySlots);
                if (value.toLowerCase() !== 'saturday' && value.toLowerCase() !== 'sunday') {
                    return (
                        <div className={styles.container} key={index}>
                            <div className={styles.header}>
                                <p>{value}</p>
                            </div>
                            <div className={`${styles.slotContainer} ${styles.multiSlot}`}>
                                {availabilitySlots?.length ? availabilitySlots?.map((slot: { startTime: string, endTime: string }, idx: number) => {
                                    return (
                                        <div className={styles.slot} key={idx}>
                                            <span>{moment(slot.startTime, 'HH:mm A').format('hh:mm A')}</span> - <span>{moment(slot.endTime, 'HH:mm A').format('hh:mm A')}</span>
                                        </div>
                                    );
                                }) : <div className={styles.closedSlot}>Closed</div>}
                            </div>
                        </div>
                    )
                } else if (value.toLowerCase() === 'sunday') {
                    return (
                        <div className={styles.container} key={index}>
                            <div className={styles.header}>
                                <p>{value}</p>
                            </div>
                            <div className={`${styles.slotContainer} ${styles.multiSlot}`}>
                                {availabilityObject?.sundaySlots?.length ? availabilityObject?.sundaySlots?.map((slot: { startTime: string, endTime: string }, idx: number) => {
                                    return (
                                        <div className={styles.slot} key={idx}>
                                            <span>{moment(slot.startTime, 'HH:mm A').format('hh:mm A')}</span> - <span>{moment(slot.endTime, 'HH:mm A').format('hh:mm A')}</span>
                                        </div>
                                    );
                                }) : <div className={styles.closedSlot}>Closed</div>}
                            </div>
                        </div>
                    )

                } else {
                    return (
                        <div className={styles.container} key={index}>
                            <div className={styles.header}>
                                <p>{value}</p>
                            </div>
                            <div className={`${styles.slotContainer} ${styles.multiSlot}`}>
                                {availabilityObject?.saturdaySlots?.length ? availabilityObject?.saturdaySlots?.map((slot: { startTime: string, endTime: string }, idx: number) => {
                                    return (
                                        <div className={styles.slot} key={idx}>
                                            <span>{moment(slot.startTime, 'HH:mm A').format('hh:mm A')}</span> - <span>{moment(slot.endTime, 'HH:mm A').format('hh:mm A')}</span>
                                        </div>
                                    );
                                }) : <div className={styles.closedSlot}>Closed</div>}
                            </div>
                        </div>
                    )
                }
            })}

            {!!availabilityObject?.satSunAvailability && availabilityObject?.isOfficeHoursChecked && weekdays?.map((value: string, index: number) => {
                if (value.toLowerCase() !== 'saturday' && value.toLowerCase() !== 'sunday') {
                    return (
                        <div className={styles.container} key={index}>
                            <div className={styles.header}>
                                <p>{value}</p>
                            </div>
                            <div className={styles.slotContainer}>
                                {availabilityObject?.availabilitySlots?.length ? availabilityObject?.availabilitySlots?.map((slot: { startTime: string, endTime: string }, idx: number) => {
                                    return (
                                        <div className={styles.slot} key={idx}>
                                            <span>{moment(slot.startTime, 'HH:mm A').format('hh:mm A')}</span> - <span>{moment(slot.endTime, 'HH:mm A').format('hh:mm A')}</span>
                                        </div>
                                    );
                                }) : <div className={styles.closedSlot}>Closed</div>}
                            </div>
                        </div>
                    );
                } else if (value.toLowerCase() === 'saturday') {
                    return (
                        <div className={styles.container} key={index}>
                            <div className={styles.header}>
                                <p>{value}</p>
                            </div>
                            <div className={styles.slotContainer}>
                                {!Array.isArray(availabilityObject?.saturdaySlots) || availabilityObject?.saturdaySlots.length === 0 ? (
                                    <div className={styles.closedSlot}>Closed</div>
                                ) : (
                                    availabilityObject?.saturdaySlots?.length ? availabilityObject?.saturdaySlots?.map((slot: { startTime: string, endTime: string }, idx: number) => {
                                        return (
                                            <div className={styles.slot} key={idx}>
                                                <span>{moment(slot.startTime, 'HH:mm A').format('hh:mm A')}</span> - <span>{moment(slot.endTime, 'HH:mm A').format('hh:mm A')}</span>
                                            </div>
                                        );
                                    }) : <div className={styles.closedSlot}>Closed</div>
                                )}
                            </div>
                        </div>
                    );
                } else if (value.toLowerCase() === 'sunday') {
                    return (
                        <div className={styles.container} key={index}>
                            <div className={styles.header}>
                                <p>{value}</p>
                            </div>
                            <div className={styles.slotContainer}>
                                {!Array.isArray(availabilityObject?.sundaySlots) || availabilityObject?.sundaySlots.length === 0 ? (
                                    <div className={styles.closedSlot}>Closed</div>
                                ) : (availabilityObject?.sundaySlots?.length ? availabilityObject?.sundaySlots?.map((slot: { startTime: string, endTime: string }, idx: number) => {
                                    return (
                                        <div className={styles.slot} key={idx}>
                                            <span>{moment(slot.startTime, 'HH:mm A').format('hh:mm A')}</span> - <span>{moment(slot.endTime, 'HH:mm A').format('hh:mm A')}</span>
                                        </div>
                                    );
                                }) : <div className={styles.closedSlot}>Closed</div>
                                )}
                            </div>
                        </div>
                    );
                }
            })}

        </div>
    );
};

export default OfficeHoursTable;
